import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-radiobox" }
const _hoisted_2 = ["value", "name", "id", "checked", "disable"]
const _hoisted_3 = ["for", "id"]


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioBox',
  props: {
  modelValue: {
    type: String,
    default: 'value',
  },
  name: {
    type: String,
    default: 'name',
  },
  id: {
    type: String,
    default: 'id',
  },
  checked: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'default',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {



// tobe
const emit = __emit;

const updateValue = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "radio",
      class: "c-radiobox__input",
      value: __props.modelValue,
      onChange: updateValue,
      name: __props.name,
      id: __props.id,
      checked: __props.checked,
      disable: __props.disabled
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: __props.id,
      class: _normalizeClass(`
        c-radiobox__label
        c-radiobox__label--${__props.color}
      `),
      id: __props.id
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_3)
  ]))
}
}

})